/**
 * Clerk authentication configuration.
 *
 * Reads the publishable key from Vite env vars and validates
 * it exists at startup. Throws a clear error in dev if missing.
 * Skips validation during test runs (vitest sets NODE_ENV=test).
 */

function getClerkPublishableKey(): string {
  const key = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY
  if (!key && typeof process !== 'undefined' && process.env?.NODE_ENV === 'test') {
    return 'pk_test_placeholder'
  }
  if (!key) {
    throw new Error(
      '[AxiomGO] VITE_CLERK_PUBLISHABLE_KEY is missing. ' +
        'Add it to your .env file. See .env.example for reference.',
    )
  }
  return key as string
}

export const CLERK_PUBLISHABLE_KEY = getClerkPublishableKey()
